import { Agent } from 'shared'
import local from '@/local'

export default {
  agent: new Agent('beta', local.version),
  error_codes: {
    too_many_events: '1000.1.1'
  },
  eventNames: {
    audioLockUpdated: 'audio.lock.updated',
    automixUpdated: 'automix.updated',
    callRoomAnswer: 'call.room.answer',
    callRoomCandidate: 'call.room.candidate',
    callRoomConnected: 'call.room.connected',
    callRoomDisconnected: 'call.room.disconnected',
    callRoomOffer: 'call.room.offer',
    callRoomParticipantUpdated: 'call.room.participant.updated',
    callRoomSessionsUpdated: 'call.room.sessions.updated',
    callRoomStart: 'call.room.start',
    callRoomStop: 'call.room.stop',
    contributionInvited: 'contribution.invited',
    contributionUpdated: 'contribution.updated',
    dispositionUpdated: 'disposition.updated',
    distributorAdded: 'distributor.added',
    distributorRemoved: 'distributor.removed',
    distributorUpdated: 'distributor.updated',
    eventFilesAvailable: 'event.files.available',
    eventUpdated: 'event.updated',
    fileAvailable: 'file.available',
    fileRemoved: 'file.removed',
    fileUpdated: 'file.updated',
    inputsSelected: 'inputs.selected',
    liveUpdated: 'live.updated',
    messageReceived: 'message.received',
    overlaysSelected: 'overlays.selected',
    rightsUpdated: 'rights.updated',
    textAdded: 'text.added',
    textRemoved: 'text.removed',
    textUpdated: 'text.updated',
    volumeUpdated: 'volume.updated',
    webRTCClientToServerCandidate: 'webrtc.client.to.server.candidate',
    webRTCServerToClientOffer: 'webrtc.server.to.client.offer',
    webRTCServerToClientAnswer: 'webrtc.server.to.client.answer',
    webRTCServerToClientCandidate: 'webrtc.server.to.client.candidate',
    welcome: 'welcome'
  }
}
